// extracted by mini-css-extract-plugin
export default {"logoBox":"index_logoBox_iHoYb","logoImg":"index_logoImg_Ua49q","MottoImg":"index_MottoImg_P0JzT"};